import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
function SlotPage() {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [slotData, setSlotData] = useState([]);
  const [editedSlotData, setEditedSlotData] = useState();
  const [editedSlotJob, setEditedSlotJob] = useState(
    editedSlotData?.jobAccepctance
  );
  const [editedSlotCharge, setEditedSlotCharge] = useState(0);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [dateFrom, setDateFrom] = useState("");
  // const [slotDate, setslotDate] = useState("");
  const [dateTo, setDateTo] = useState("");
  // const [slots, setSlots] = useState([]);
  const [timeFrom, setTimeFrom] = useState("");
  const [timeTo, setTimeTo] = useState("");
  const [duration, setDuration] = useState("");
  const [jobAccepctance, setjobAccepctance] = useState("");
  const [parentCategory, setParentCategoryGroups] = useState([]);
  const [loading, setLoading] = useState("");
  const [selectedGroup, setSelectedGroup] = useState();
  const [selectGroupForNew, setSelectGroupForNew] = useState();

  const [createValid, setCreateValid] = useState(false);

  useEffect(() => {
    if (timeFrom && timeTo && duration && jobAccepctance && selectGroupForNew) {
      setCreateValid(true);
    }
  }, [timeFrom, timeTo, duration, jobAccepctance, selectGroupForNew]);

  const [selectedGroupLabel, setSelectedGroupLabel] = useState();

  const clearInputs = () => {
    setDateFrom("");
    setDateTo("");
    setTimeFrom("");
    setTimeTo("");
    setDuration("");
    setjobAccepctance("");
    setSelectGroupForNew({});
  };

  const getSlots = async (date, PcatId) => {
    try {
      setLoading(true);
      let url = `AppoinmentSlot/SlotByParentId?date=${date}&PcatgroupId=${PcatId}`;
      const response = await privateRequest.get(url);
      setSlotData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategoryGroup/GetParentcategory`
      );
      setParentCategoryGroups(response?.data?.Data);
      // setSelectedGroup
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleGroupChange = (selectedOption) => {
    setSelectedGroup(selectedOption);
    getSlots(selectedDate, selectedOption);
  };

  useEffect(() => {
    if (parentCategory) {
      let selectedOption = parentCategory[0]?._id;

      handleGroupChange(selectedOption);
      getSlots(selectedDate, parentCategory[0]?._id);
    }
  }, [parentCategory]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await privateRequest.post(`AppoinmentSlot/CreateAppoinmentSlot`, {
        Pcatgroup: selectedGroup,
        dateFrom,
        dateTo,
        timeFrom,
        timeTo,
        duration,
        jobAccepctance,
      });

      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "slots created succesfully",
      });
      getSlots(selectedDate, parentCategory[0]?._id);
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.message,
      });
    }
  };
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      let response = await privateRequest.put(
        "AppoinmentSlot/UpdatetAppoinmentSlot/" + editedSlotData?.itemId,
        {
          jobAcceptance: parseInt(editedSlotJob),
          surgCharges: parseInt(editedSlotCharge),
          slotId: editedSlotData?.slotId,
        }
      );
      if (response) {
        // getSlots(selectedDate);
        getSlots(selectedDate, parentCategory[0]?._id);
      }
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "slots created succesfully",
      });
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.message,
      });
    }
  };
  const handleEditStatus = async (e, id, itemId) => {
    try {
      let response = await privateRequest.post(
        "AppoinmentSlot/UpdateStatusButton/" + itemId,
        {
          slotId: id,
          statusButton: e,
        }
      );
      if (response) {
        getSlots(selectedDate, parentCategory[0]?._id);
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.message,
      });
    }
  };

  useEffect(() => {
    getParentCategory();
    getSlots(selectedDate);
  }, [selectedDate]);

  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Slots</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      type="button"
                      data-toggle="modal"
                      data-target="#addHeroSliderModal"
                      onClick={() => {
                        setjobAccepctance(0);
                        clearInputs();
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-header pb-0">
                      <div className="row">
                        <div className="col-lg-3">
                          <div className="form-group">
                            <div className="form-group">
                              <select
                                className="form-control"
                                value={selectedGroup}
                                onChange={(e) =>
                                  handleGroupChange(e.target.value)
                                }
                              >
                                <option value="">Select</option>
                                {parentCategory &&
                                  parentCategory.map((group) => (
                                    <option value={group._id}>
                                      {group.PCGName}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <input
                              type="date"
                              id="dateFilter"
                              className="form-control"
                              value={selectedDate}
                              onChange={(e) => setSelectedDate(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {loading == true ? (
                      <div className="d-flex justify-content-center align-items-center p-5">
                        <div
                          class="spinner-border text-dark loader my-5"
                          role="status"
                          style={{
                            width: "150px",
                            height: "150px",
                          }}
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="card-body">
                          {slotData.length === 0 && (
                            <p className="text-center font-weight-bolder p-5">
                              No slots available On This Date:
                              <br /> {selectedDate}
                            </p>
                          )}
                          {slotData.map((item, index) => (
                            <div key={index} className="row">
                              {item.slot.map((slot, subIndex) => {
                                return (
                                  <div key={subIndex} className="col-lg-3">
                                    <div className="card">
                                      <div className="card-header d-flex justify-content-between align-items-center py-2">
                                        <div>
                                          <span className="d-block">
                                            {slot.slotTime}
                                          </span>
                                          {slot.surgCharges > 0 && (
                                            <span className="badge badge-danger pt-1">
                                              ₹ {slot.surgCharges}
                                            </span>
                                          )}
                                        </div>

                                        <button
                                          role="button"
                                          data-toggle="modal"
                                          data-target="#editHeroSliderModal"
                                          onClick={() => {
                                            let EditedSlot = {
                                              time: slot?.slotTime,
                                              charges: slot?.surgCharges,
                                              date: item?.slotDate,
                                              jobAccepctance:
                                                slot.jobAcceptance,
                                              slotId: slot?._id,
                                              pcatgroup:
                                                item?.Pcatgroup?.PCGName,
                                              itemId: item?._id,
                                            };

                                            setEditedSlotData(EditedSlot);
                                            setEditedSlotCharge(
                                              slot?.surgCharges
                                            );
                                            setEditedSlotJob(
                                              slot.jobAcceptance
                                            );
                                          }}
                                          className="btn btn-primary btn-sm btn-icon ml-2"
                                        >
                                          <i className="fa fa-edit"></i>
                                        </button>
                                      </div>
                                      <div className="card-body">
                                        <p
                                          style={{
                                            margin: "0",
                                            textAlign: "center",
                                          }}
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            Job Acceptance:
                                          </span>
                                          <br />
                                          {slot.jobAcceptance}
                                        </p>
                                      </div>
                                      <div className="card-footer p-2 px-3 d-inline-block">
                                        <div className="row">
                                          <div className="col-lg-6">
                                            <div className="text-center">
                                              <p className="mb-0">Job Booked</p>
                                              <h4 className="card-title mb-0">
                                                {slot.jobCount}
                                              </h4>
                                            </div>
                                          </div>
                                          <div className="col-lg-6 text-right">
                                            <label className="switcher-control switcher-control-lg">
                                              <input
                                                type="checkbox"
                                                value={
                                                  !slot?.statusButton ||
                                                  slot?.statusButton == false
                                                    ? true
                                                    : false
                                                }
                                                checked={
                                                  !slot?.statusButton ||
                                                  slot?.statusButton == false
                                                    ? false
                                                    : true
                                                }
                                                className="switcher-input"
                                                onChange={(e) => {
                                                  console.log(
                                                    "e.target.value",
                                                    e.target.value
                                                  );
                                                  handleEditStatus(
                                                    e.target.value,
                                                    slot?._id,
                                                    item?._id
                                                  );
                                                }}
                                              />
                                              <span
                                                className="switcher-indicator switcher"
                                                data-id="8588"
                                              ></span>
                                              <span
                                                className="switcher-label-on switcher"
                                                data-id="8588"
                                              >
                                                ON
                                              </span>
                                              <span
                                                className="switcher-label-off switcher"
                                                data-id="8588"
                                              >
                                                OFF
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <div
        className={`modal fade`}
        id="addHeroSliderModal"
        role="dialog"
        data-backdrop="static"
        tabindex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Slots
              </h5>
              <button
                type="button"
                className="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Date From</label>
                      <input
                        min={today}
                        type="date"
                        className="form-control"
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Date To</label>
                      <input
                        min={today}
                        type="date"
                        className="form-control"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Time From</label>
                      <input
                        value={timeFrom}
                        onChange={(e) => setTimeFrom(e.target.value)}
                        // type="time"
                        type="time"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Time To</label>
                      <input
                        value={timeTo}
                        onChange={(e) => setTimeTo(e.target.value)}
                        type="time"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Select Duration</label>
                      <select
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                        className="form-control"
                      >
                        <option>Select Duration</option>
                        <option value="15">15 </option>
                        <option value="30">30</option>
                        <option value="45">45</option>
                        <option value="60">60</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Job Acceptence</label>

                      <input
                        value={jobAccepctance}
                        onChange={(e) => {
                          setjobAccepctance(e.target.value);
                        }}
                        type="Number"
                        className="form-control"
                        placeholder="Job Acceptence"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Select Category</label>
                      <select
                        className="form-control"
                        value={selectGroupForNew}
                        onChange={(e) => setSelectGroupForNew(e.target.value)}
                      >
                        <option value="">Select</option>
                        {parentCategory &&
                          parentCategory.map((group) => (
                            <option value={group._id}>{group.PCGName}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                </div>
                <hr className="mt-0" />

                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        {...(createValid && { "data-dismiss": "modal" })}
                        className="btn btn-primary"
                      >
                        submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className={"modal fade"}
        id="editHeroSliderModal"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Slots
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setEditedSlotJob(0)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form
                onSubmit={handleEditSubmit}
                id="slot_edit"
                className="needs-validation"
                noValidate
              >
                <div className="row">
                  <div className="form-group col-lg-4">
                    <label>Date From</label>
                    <input
                      type="text"
                      disabled
                      value={editedSlotData?.date}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group col-lg-4">
                    <label>Time From</label>
                    <input
                      type="text"
                      disabled
                      value={editedSlotData?.time}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group col-lg-4">
                    <label>Job Acceptance</label>
                    <input
                      type="number"
                      value={editedSlotJob}
                      required
                      onChange={(e) => {
                        setEditedSlotJob(e.target.value);
                      }}
                      name="txtJobAcceptence"
                      id="txtJobAcceptence"
                      className="form-control"
                      placeholder="Job Acceptance"
                    />
                  </div>
                  <div className="form-group col-lg-4">
                    <label>Select Category</label>
                    <input
                      readOnly
                      value={editedSlotData?.pcatgroup}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group col-lg-4">
                    <label>Surg Amount</label>
                    <input
                      type="number"
                      value={editedSlotCharge}
                      required
                      name="txtsurg_amt"
                      id="txtsurg_amt"
                      className="form-control"
                      placeholder="Surg Amount"
                      onChange={(e) => {
                        setEditedSlotCharge(e.target.value);
                      }}
                    />
                  </div>
                  <input type="hidden" defaultValue="edit_slot" name="action" />
                  <input type="hidden" defaultValue="8742" name="slot_id" />
                  <div className="form-group col-lg-12">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={(e) => {
                        handleEditSubmit(e);
                      }}
                    >
                      Update Slot
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SlotPage;
